import type { SiteCopy } from '../../content'

type OfferStripBlockProps = { facts: SiteCopy['facts'] }

export function OfferStripBlock({ facts }: OfferStripBlockProps) {
  return <section className="offer-strip" aria-label="Key facts"><div className="container offer-grid">
    {facts.map(([title, body]) => <article className="offer-fact" key={title}><strong>{title}</strong><span>{body}</span></article>)}
  </div></section>
}
